import React, { useState } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    gdpr: false,
  });
  const [formError, setFormError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const target = e.target as HTMLInputElement; // Aggiunto il cast per Input
    const { id, value, type } = e.target;
    setFormData({
      ...formData,
      [id]: type === "checkbox" ? target.checked : value, // Usato 'target.checked'
    });
  };

  const handleCaptchaChange = (token: string | null) => {
    setCaptchaToken(token || "");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.gdpr) {
      setFormError("Devi accettare la GDPR prima di inviare il modulo.");
      return;
    }

    if (!captchaToken) {
      setFormError("Devi completare la verifica reCAPTCHA.");
      return;
    }

    setFormError("");
    setSuccessMessage("");

    // Your EmailJS service ID, template ID, and Public Key
    const serviceId = 'service_32tmz1v';
    const templateId = 'template_r1fneah';
    const publicKey = 'XW1Q_xVbVe9TEkFj4';

    // Create an object with EmailJS service ID, template ID, Public Key, and Template params
    const data = {
      service_id: serviceId,
      template_id: templateId,
      user_id: publicKey,
      template_params: {
        from_name: formData.name,
        from_email: formData.email,
        to_name: 'RIAMA | Contatti',
        message: formData.message,
        'g-recaptcha-response': captchaToken, 
      }
    };

    // Send the email using EmailJS
    try {
      const res = await axios.post("https://api.emailjs.com/api/v1.0/email/send", data);
      setSuccessMessage("Messaggio inviato con successo!");
      setFormData({
        name: "",
        email: "",
        message: "",
        gdpr: false,
      });

      setCaptchaToken(""); 
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-gray-100 p-8 rounded-lg shadow-lg max-w-xl mx-auto"
    >
      <div className="mb-6">
        <label htmlFor="name" className="block text-lg font-medium text-riama-blue">
          Nome
        </label>
        <input
          type="text"
          id="name"
          value={formData.name}
          onChange={handleInputChange}
          className="w-full mt-2 p-3 border rounded-md"
          placeholder="Il tuo nome"
          required
        />
      </div>
      <div className="mb-6">
        <label htmlFor="email" className="block text-lg font-medium text-riama-blue">
          Email
        </label>
        <input
          type="email"
          id="email"
          value={formData.email}
          onChange={handleInputChange}
          className="w-full mt-2 p-3 border rounded-md"
          placeholder="La tua email"
          required
        />
      </div>
      <div className="mb-6">
        <label htmlFor="message" className="block text-lg font-medium text-riama-blue">
          Messaggio
        </label>
        <textarea
          id="message"
          value={formData.message}
          onChange={handleInputChange}
          className="w-full mt-2 p-3 border rounded-md"
          rows={4}
          placeholder="Scrivi il tuo messaggio"
          required
        ></textarea>
      </div>
      <div className="mb-6 flex items-center">
        <input
          type="checkbox"
          id="gdpr"
          checked={formData.gdpr}
          onChange={handleInputChange}
          className="mr-2"
        />
        <label htmlFor="gdpr" className="text-sm text-riama-blue">
          Accetto la gestione dei dati secondo le normative GDPR.
        </label>
      </div>
      <div className="mb-6">
        <ReCAPTCHA
          sitekey="6LcFva8qAAAAAHaHPBLhy21TkCM8z1opu6N86KC8"
          onChange={handleCaptchaChange}
        />
      </div>
      {formError && <p className="text-red-500 text-sm mb-4">{formError}</p>}
      {successMessage && (
        <p className="text-green-500 text-sm mb-4">{successMessage}</p>
      )}
      <button
        type="submit"
        className="bg-riama-blue text-white px-6 py-3 rounded-md hover:bg-riama-red"
      >
        Invia
      </button>
    </form>
  );
};

export default ContactForm;